var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("el-input", {
        attrs: {
          type: "textarea",
          maxlength: _vm.state.maxlength,
          placeholder: _vm.placeholder,
          autosize: { minRows: 2 },
        },
        on: { change: _vm.changed },
        model: {
          value: _vm.model,
          callback: function ($$v) {
            _vm.model = $$v
          },
          expression: "model",
        },
      }),
      _c("div", { staticClass: "text-r" }, [
        _c("span", {
          style:
            "color:" +
            (_vm.state.maxlength - _vm.model.length <= _vm.state.warnlength
              ? "red"
              : "#666"),
          domProps: {
            textContent: _vm._s(_vm.state.maxlength - _vm.model.length),
          },
        }),
        _c("span", [_vm._v(" / " + _vm._s(_vm.state.maxlength))]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }